'use client'

import { datadogLogs } from '@datadog/browser-logs'
import { useEffect } from 'react'
import { createUncaughtErrorForwarder, UNCAUGHT_ERROR_LOG } from './uncaughtErrors'

// One budget a page load, whatever the component's mounts.
const uncaughtErrors = createUncaughtErrorForwarder((line) => {
  datadogLogs.logger.error(UNCAUGHT_ERROR_LOG, line.context, line.error)
})

export function DatadogBrowserLog() {
  useEffect(() => {
    const initDatadogBrowserLogs = (): boolean => {
      const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT

      if (!clientToken) {
        return false
      }

      // The build's id, set by the deploy's build step (deploy-vercel.yml): the
      // release's version on a tag, else the commit. The share of sessions
      // still on an older build is counted off it. Left out where the build
      // has none (a local build).
      const version = process.env.NEXT_PUBLIC_WIDGET_VERSION

      datadogLogs.init({
        clientToken,
        env: process.env.NEXT_PUBLIC_ENV,
        ...(version ? { version } : {}),
        site: 'datadoghq.eu',
        // Off: it would also forward every console.error and every failed
        // request. Uncaught errors go through `uncaughtErrors` below instead,
        // bounded per page.
        forwardErrorsToLogs: false,
        sessionSampleRate: 100,
        service: 'game-widget',
        usePartitionedCrossSiteSessionCookie: true,
        useSecureSessionCookie: process.env.NEXT_PUBLIC_ENV === 'production',
        beforeSend() {
          return ['production', 'staging'].includes(process.env.NEXT_PUBLIC_ENV)
        }
      })
      return true
    }

    if (!initDatadogBrowserLogs()) return undefined

    window.addEventListener('error', uncaughtErrors.onError)
    window.addEventListener('unhandledrejection', uncaughtErrors.onRejection)
    return () => {
      window.removeEventListener('error', uncaughtErrors.onError)
      window.removeEventListener('unhandledrejection', uncaughtErrors.onRejection)
    }
  }, [])

  return null
}
